import { InjectionToken } from '@angular/core'

import { Translations } from './translations.type'

export const TRANSLATIONS = new InjectionToken<Translations>(ngDevMode ? 'TRANSLATIONS' : '')
